import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useApp } from "../store";

export const CookieBanner = () => {
  const { t } = useApp();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("pgp_consent")) {
      const timer = setTimeout(() => setVisible(true), 2500);
      return () => clearTimeout(timer);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem("pgp_consent", value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-banner"
          role="dialog"
          aria-live="polite"
          className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:left-6 sm:bottom-6 sm:max-w-md z-[60] bg-[#0F1D3D]/95 backdrop-blur-xl border border-[var(--accent-soft)]/10 p-5 sm:p-6 shadow-2xl"
        >
          <div className="flex items-start gap-4">
            <span className="w-10 h-10 shrink-0 grid place-items-center border border-[var(--accent)]/40 text-[var(--accent)]">
              <Cookie size={18} />
            </span>
            <div>
              <p data-testid="cookie-banner-text" className="text-sm text-white/70 leading-relaxed">
                {t("cookie_text")}
              </p>
              <Link
                data-testid="cookie-more-link"
                to="/mentions-legales"
                className="mt-2 inline-block text-xs text-[var(--accent)] hover:underline"
              >
                {t("cookie_more")} →
              </Link>
            </div>
          </div>
          <div className="mt-4 flex gap-2 justify-end">
            <button
              data-testid="cookie-decline-button"
              onClick={() => choose("declined")}
              className="text-xs border border-[var(--accent-soft)]/20 hover:border-[var(--accent-soft)]/50 text-white/60 hover:text-white px-4 py-2.5 rounded-full transition-colors duration-300"
            >
              {t("cookie_decline")}
            </button>
            <button
              data-testid="cookie-accept-button"
              onClick={() => choose("accepted")}
              className="text-xs bg-[var(--accent)] hover:bg-[var(--accent-soft)] text-white font-semibold px-5 py-2.5 rounded-full transition-colors duration-300"
            >
              {t("cookie_accept")}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
